import { SaldoThreshold } from '../../../application/types/saldoThreshold.ts';
import { axiosInstance } from '../../../common/axiosInstans.ts';
import { AxiosResponse } from 'axios';
import { CreateStorageRequest } from '../../../application/types/requests/createStorageRequest.ts';
import { StorageLocation as StorageLocation } from '../../../application/types/storageLocation.ts';
import { Drug } from '../../../application/types/drug.ts';
// import { SaldoThresholds } from '../../../application/types/saldoThresholds.ts';

class StorageService {
    async createStorage(storage: CreateStorageRequest) {
        try {
            const response = await axiosInstance.post(
                '/storagelocation',
                storage
            );
            return response.data;
        } catch (error) {
            console.error('Error creating storage location:', error);
            throw error;
        }
    }

    async saveSaldoThreshold(saldoThreshold: SaldoThreshold) {
        try {
            return await axiosInstance.post(
                '/storagelocation/saldo-threshold/add',
                saldoThreshold
            );
        } catch (error) {
            console.error('Error saving saldo threshold:', error);
            throw error;
        }
    }

    async deleteSaldoThreshold(id: number) {
        try {
            await axiosInstance.delete(
                `/storagelocation/saldo-threshold/${id}`
            );
        } catch (error) {
            console.error('Error deleting saldo threshold:', error);
            throw error;
        }
    }

    // Get saldo-threshold of storage(id)
    async getSaldoThreshold(id: string): Promise<AxiosResponse> {
        try {
            const res = await axiosInstance.get(
                `/storagelocation/saldo-threshold/${id}`
            );
            return res;
        } catch (error) {
            console.error('Error getting saldo threshold:', error);
            throw error;
        }
    }

    async getStorageInventory(id: string): Promise<AxiosResponse> {
        try {
            return await axiosInstance.get(`/storagelocation/${id}/inventory`);
        } catch (error) {
            console.error('Error updating saldo threshold:', error);
            throw error;
        }
    }

    async getDrugsForStorage(id: string): Promise<Drug[]> {
        try {
            const { data } = await axiosInstance.get(
                `/storagelocation/${id}/inventory`
            );
            return data?.inventories?.map((inventory: any) => {
                return inventory?.drug;
            });
        } catch (error) {
            console.error('Error updating saldo threshold:', error);
            throw error;
        }
    }

    async deleteStorage(id: string): Promise<void> {
        await axiosInstance.delete(`/storagelocation/${id}`);
    }

    async getAllStorages(): Promise<StorageLocation[]> {
        try {
            const { data } = await axiosInstance.get('/storagelocation');
            return data;
        } catch (error) {
            console.error('Error getting all storages:', error);
            throw error;
        }
    }

    // this is ambulance bags/emergency bags
    async getSateliteStorages(): Promise<StorageLocation[]> {
        try {
            const { data } = await axiosInstance.get(
                '/storagelocation/satelite'
            );
            return data;
        } catch (error) {
            console.error('Error getting all storages:', error);
            throw error;
        }
    }

    // this is all other storages, usally in a hospital
    async getNoneSateliteStorages(): Promise<StorageLocation[]> {
        try {
            const { data } = await axiosInstance.get(
                '/storagelocation/nonesatelite'
            );
            return data;
        } catch (error) {
            console.error('Error getting all storages:', error);
            throw error;
        }
    }

    async getStorageByBarCode(barCode: string): Promise<StorageLocation> {
        try {
            const { data } = await axiosInstance.get(
                `/storagelocation/barcode/${barCode}`
            );
            return data;
        } catch (error) {
            console.error('Error getting storage from barcode:', error);
            throw error;
        }
    }

    async updateStorage(updatedStorageData: StorageLocation): Promise<void> {
        try {
            await axiosInstance.put(
                '/storagelocation/inventory',
                updatedStorageData
            );
        } catch (error) {
            console.error('Error updating storage:', error);
            throw error;
        }
    }

    async updateSaldoThresholds(
        saldoThresholds: SaldoThreshold[]
    ): Promise<void> {
        try {
            await axiosInstance.put(
                '/storagelocation/saldo-thresholds',
                saldoThresholds
            );
        } catch (error) {
            console.error('Error updating saldo thresholds:', error);
            throw error;
        }
    }
}

export default StorageService;
